var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup',{ref:"workflowmodal",attrs:{"buttonText":"Add Workflow","heading":"Add Workflow","button-icon":"fa fa-plus","button-size":"small","button-style":"primary","round":"","plain":""},on:{"save":_vm.addWorkflow}},[_c('edit-workflow',{attrs:{"is-add":"","row-data":_vm.formData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }